import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import { CreateCategoryContext, ICreateCategoryContext } from '../../../createCategoryState/createCategoryContext';
import React, { useContext } from 'react';
import { InputFields } from './components/InputFields';
import style from './CreationForm.module.scss';

const descriptionOfAspectRatio = {
	horizontal: {
		ratio: '13:8',
		optimalResolutions: {
			a: '208*128px',
			b: '416*256px',
		},
	},
	vertical: {
		ratio: '13:8',
		optimalResolutions: {
			a: '208*128px',
			b: '416*256px',
		},
	},
};

export const CreationForm: React.FC = () => {
	const { setFileId, fileId } = useContext<ICreateCategoryContext>(CreateCategoryContext);

	const deletePhotoHandler = () => {
		setFileId(null);
	};

	return (
		<div className={style.container} data-test="CreationForm">
			<FormImageUploader
				containerClass={style.imageUploader}
				maxFileSizeMB={1}
				fileId={fileId}
				deletePhotoHandler={deletePhotoHandler}
				setFileId={setFileId}
				horizontalAspectRatio={208 / 128}
				verticalAspectRatio={208 / 128}
				descriptionOfAspectRatio={descriptionOfAspectRatio}
			/>
			<InputFields />
		</div>
	);
};
